import { resolveLocale } from '@/translations/helpers';
import axios from 'axios';
import { generateNewToken } from '@/store/actions/tokenAction';
import minions from '@/minions/minions';

let isRefreshing = false;
let pendingRequests = [];

const resolvePending = (token) => {
  pendingRequests.forEach((cb) => cb(token));
  pendingRequests = [];
};

const axiosInterceptor = async () => {
  axios.interceptors.request.use(
    async (config) => {
      if (
        !config.url?.includes('api/u/login') &&
        !config.url?.includes('api/u/token/refresh')
      ) {
        const token = await localStorage.getItem('t');
        config.headers.Authorization = `Bearer ${token}`;
      }
      // Importante para el idioma de navegación
      config.headers['Accept-Language'] = resolveLocale();
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    async (e) => {
      const originalRequest = e.config;

      // NO interceptar el refresh
      if (
        originalRequest.url.includes('/api/u/token/refresh') ||
        originalRequest.url.includes('/api/u/login')
      ) {
        return Promise.reject(e);
      }
      if (e?.response?.status === 401) {
        // Si ya se está refrescando, ponemos la request en cola
        if (isRefreshing) {
          return new Promise((resolve) => {
            pendingRequests.push((token) => {
              e.config.headers.Authorization = `Bearer ${token}`;
              resolve(axios(e.config));
            });
          });
        }

        isRefreshing = true;

        try {
          const refreshtoken = localStorage.getItem('rt');
          const t = await generateNewToken(refreshtoken);

          if (!t) {
            minions.auth.logout();
            return Promise.reject(e);
          }

          localStorage.setItem('t', t.token);
          localStorage.setItem('rt', t.refreshToken);

          // Desbloqueamos las requests en cola
          resolvePending(t.token);

          // Reintentamos la request original
          e.config.headers.Authorization = `Bearer ${t.token}`;
          return axios(e.config);
        } catch (err) {
          localStorage.removeItem('t');
          localStorage.removeItem('rt');
          window.location.href = `${window.location.origin}/login/`;
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(e);
    }
  );
  return axios;
};

export default axiosInterceptor;
